// Known-safe fallback values for this project (used when env vars are not injected)
const FALLBACK_SUPABASE_URL = "https://dpxpmppipxlcyuktaqjz.supabase.co";
const FALLBACK_SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRweHBtcHBpcHhsY3l1a3RhcWp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI0NjIwNTEsImV4cCI6MjA3ODAzODA1MX0.4-HfYg5KLHqcrKFG2LWlXZhiPyi8HYebd_ZgQWDhLvQ";
const FALLBACK_PROJECT_ID = "dpxpmppipxlcyuktaqjz";

export type Env = {
  VITE_SUPABASE_URL: string;
  VITE_SUPABASE_PUBLISHABLE_KEY: string;
  VITE_SUPABASE_PROJECT_ID: string;
};

// Vite injects VITE_* prefixed env vars at build time from .env file
// The .env file is auto-managed by Lovable Cloud
// Fallbacks ensure the app boots reliably even if env vars aren't injected yet
const resolveEnv = (): Env => {
  const url = import.meta.env.VITE_SUPABASE_URL || FALLBACK_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_SUPABASE_KEY;
  const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID || FALLBACK_PROJECT_ID;

  const usedFallback = 
    !import.meta.env.VITE_SUPABASE_URL || 
    !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 
    !import.meta.env.VITE_SUPABASE_PROJECT_ID;

  if (usedFallback && import.meta.env.DEV) {
    console.warn("[ENV] Using fallback Supabase configuration (env vars not injected)");
  }

  return {
    VITE_SUPABASE_URL: url,
    VITE_SUPABASE_PUBLISHABLE_KEY: key,
    VITE_SUPABASE_PROJECT_ID: projectId,
  };
};

export const env: Env = resolveEnv();

// Debug logging only in development
if (import.meta.env.DEV) {
  console.debug("[ENV] Environment loaded", {
    hasUrl: Boolean(env.VITE_SUPABASE_URL),
    hasKey: Boolean(env.VITE_SUPABASE_PUBLISHABLE_KEY),
    hasProjectId: Boolean(env.VITE_SUPABASE_PROJECT_ID),
  });
}
